export default {
  'commissionmanagement.commissionmanagement': 'Punktverwaltung',
  'commissionmanagement.accountsnotify':
    'Bitte erstellen Sie ein Bankkonto von',
  'commissionmanagement.accountsnotify1':
    'Verknüpfen, wenn Sie kein Konto haben',
  'commissionmanagement.accountmanagement': 'Bankkontoverwaltung',
  'commissionmanagement.description': 'Beschreibung',
  'commissionmanagement.bankaccount': 'Konto Nr',
  'commissionmanagement.save': 'speichern',
  'commissionmanagement.addrequest': 'Rücknahmeantrag senden',
  'commissionmanagement.withdrawamount': 'Betrag beheben',
  'commissionmanagement.index': 'Index',
  'commissionmanagement.requestdate': 'Anforderungsdatum',
  'commissionmanagement.requeststatus': 'Anforderungsstatus',
  'commissionmanagement.withdrawtype': 'Auszahlungstyp',
  'commissionmanagement.requestadd':
    'Auszahlungsanforderung wurde erfolgreich hinzugefügt',
  'commissionmanagement.tryagain': 'Bitte versuche es erneut',
  'commissionmanagement.deleterequest': 'Auszahlungsanforderung löschen',
  'commissionmanagement.deleteerror':
    "Diese Anfrage kann nicht gelöscht werden ',' Provisionsverwaltung.nicht bestätigt ':' nicht bestätigt",
  'commissionmanagement.approve': 'Bestätigen',
  'commissionmanagement.disapprove': 'missbilligen',
  'commissionmanagement.pending': 'ausstehend',
  'commissionmanagement.notpaid': 'nicht bezahlt',
  'commissionmanagement.paid': 'bezahlt',
  'commissionmanagement.showdetail': 'zeige Details',
  'commissionmanagement.incomedetail': 'Einkommensdetails',
  'commissionmanagement.withdrawreport': 'Transaktionsbericht',
  'commissionmanagement.transferpoints': 'Übergabepunkte',
  'commissionmanagement.buycard': 'Telefonkarte kaufen',
  'commissionmanagement.paybill': 'Rechnung bezahlen',
  'commissionmanagement.spendpoints': 'Punkt ausgeben',
  'commissionmanagement.lottery': 'Lotterie',
  'commissionmanagement.earnpoints': 'Punkt verdienen',
  'commissionmanagement.redandantrequest':
    'Es steht eine Anfrage aus. Bitte senden Sie keine weitere Anfrage',
  'commissionmanagement.exitfee': 'Ausgangsgebühr bezahlen',
  'commissionmanagement.requestreport': 'Bericht über Anfragen zurückziehen',
  'commissionmanagement.phrase': 'Dokumentnummer',
  'commissionmanagement.documentdescription': 'Dokumentbeschreibung',
  'commissionmanagement.transferamount': 'Übertragbare Punkte',
  'commissionmanagement.pointamount': 'Punktbetrag',
  'commissionmanagement.secondpassword': 'Zweites Passwort',
  'commissionmanagement.transfererror':
    'Die Anzahl der angeforderten Punkte ist höher als die Anzahl der verbleibenden Punkte',
  'commissionmanagement.resecondpassword':
    'Geben Sie das zweite PAssword erneut ein ',
  'commissionmanagement.wagenotify1': 'Stimmen Sie zu, ',
  'commissionmanagement.wagenotify2': 'Punkt für den Lohn abzuziehen? ',
  'commissionmanagement.errorsecondpassword':
    'Das zweite Passwort ist nicht registriert. Bitte geben Sie zuerst das zweite Passwort ein',
  'commissionmanagement.wrongsecondpassword': 'Das zweite Passwort ist falsch!',
  'commissionmanagement.successtransfer': 'Punkte erfolgreich übertragen',
  'commissionmanagement.notenoughpoint':
    'Die angeforderten Punkte sind aufgrund Ihrer gesperrten Punkte nicht zulässig',
  'commissionmanagement.sameprofiles': 'Sender ist der gleiche wie Empfänger',
  'commissionmanagement.deleteconfirm':
    'Sind Sie sicher, die Anforderung zum Zurückziehen von Punkten zu löschen?',
  'commissionmanagement.customer': 'Kundin',
  'commissionmanagement.employee': 'Angestellte',
  'commissionmanagement.request': 'Anfragen',
  'commissionmanagement.income': 'Ihr Einkommen',
  'commissionmanagement.wallet': 'Aktualisieren Sie Ihre Brieftasche',
  'commissionmanagement.customerregion': 'Kundenbasierte Region',
  'commissionmanagement.totalpoint': 'Gesamtpunktzahl',
  'commissionmanagement.requestprice': 'Angeforderter Betrag',
  'commissionmanagement.sendsms': 'SMS senden',
  'commissionmanagement.requestpoint': 'Angeforderter Punkt',
  'commissionmanagement.wallettransaction': 'Letzte Wallet-Transaktionen',
  'commissionmanagement.recenttransactions': 'kürzliche Transaktionen',
  'commissionmanagement.pointtransactions': 'Punktetransaktionen',
  'commissionmanagement.transitional': 'Übergangszeit',
  'commissionmanagement.exitfeepayment': 'Zahlungsausstiegsgebühr',
  'commissionmanagement.moneydescription':
    'Sie können Ihre Punkte in Geld umwandeln und auf Ihr Bankkonto einzahlen.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'Auf diese Weise können Sie Ihre Punkte an Tripsi-Benutzer übertragen.',
  'commissionmanagement.transferpointdescriptionTripord':
    'Auf diese Weise können Sie Ihre Punkte an Tripord-Benutzer übertragen.',
  'commissionmanagement.getpointdescription':
    'Es gibt mehrere Möglichkeiten, Ihre Punkte zu erhöhen und kostenlose Fahrten zu erhalten.',
  'commissionmanagement.spendpointdescription':
    'Durch die Punkte können Sie die Karte von Hamrah Aval,Irancell und Taliya kostenlos erhalten.',
  'commissionmanagement.buycarddescription':
    'Durch die Punkte können Sie die Karte von Hamrah Aval,Irancell und Taliya kostenlos erhalten.',
  'commissionmanagement.exitfeedescription':
    'Mit Ihren Punkten können Sie Ausreisesteuern bezahlen.',
  'commissionmanagement.buypoint': 'Kaufpunkt',
  'commissionmanagement.safeway': 'Der sicherste Weg',
  'commissionmanagement.spendanywhere': 'Verbringen Sie überall',
  'commissionmanagement.deposit': 'Konto einzahlen',
  'commissionmanagement.easyway': 'Der einfachste Weg',
  'commissionmanagement.fastway': 'Der schnellste Weg',
  'commissionmanagement.entersecondpassword': 'Zweites Passwort eingeben',
  'commissionmanagement.usepoint': 'Mein lieber Freund, nutze die Punkte gut',
  'commissionmanagement.transfermoney': 'Geld überweisen',
  'commissionmanagement.buyCard': 'Karte kaufen',
  'commissionmanagement.textRequest':
    'Über das untenstehende Formular können Sie Ihre Punkte in Geld umwandeln.',
  'commissionmanagement.textTransferpoints':
    'Sie können Ihre Punkte über das untenstehende Formular auf ein anderes Benutzerkonto übertragen.',
  'commissionmanagement.InternalServer': 'Interner Serverfehler',
};
